import { Condition2Art } from './components/Condition2Art/Condition2Art'
import { Condition3Art } from './components/Condition3Art/Condition3Art'
import { Condition4Art } from './components/Condition4Art/Condition4Art'
import { Condition5Art } from './components/Condition5Art/Condition5Art'
import { Condition6Art } from './components/Condition6Art/Condition6Art'
import { Condition7Art } from './components/Condition7Art/Condition7Art'
import { Condition8Art } from './components/Condition8Art/Condition8Art'
import { Condition1Art } from './components/Condtion1Art/Condition1Art'

export const CONDITION_ART_STEPS = {
  1: Condition1Art,
  2: Condition2Art,
  3: Condition3Art,
  4: Condition4Art,
  5: Condition5Art,
  6: Condition6Art,
  7: Condition7Art,
  8: Condition8Art,
} as const

export const REWARD_ART_STEPS = {}

export type ConditionStep = keyof typeof CONDITION_ART_STEPS
